"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateConfig = void 0;
const constants_1 = require("../constants");
const updateConfig = config => ({
    type: constants_1.UPDATE_CONFIG,
    config,
});
exports.updateConfig = updateConfig;
const configReducer = (state = {}, { type, ...action }) => {
    switch (type) {
        case constants_1.UPDATE_CONFIG: {
            return {
                ...state,
                ...action.config,
            };
        }
        default:
            return state;
    }
};
exports.default = configReducer;
//# sourceMappingURL=config.js.map